import { cn } from '../../lib/utils'

export const Badge = ({ 
  children, 
  variant = 'default', 
  className,
  ...props 
}) => {
  const variantClasses = {
    default: 'badge-gray',
    primary: 'badge-primary',
    success: 'badge-success',
    warning: 'badge-warning',
    danger: 'badge-danger',
    gray: 'badge-gray',
  }

  return (
    <span
      className={cn('badge', variantClasses[variant], className)}
      {...props}
    >
      {children}
    </span>
  )
}

export default Badge
